//@flow

import React, { useState } from "react";
import Form from "react-bootstrap/Form";

import {ActionButton, PromiseWatcher} from "@/components";
import {classNameOf, HubspotForm} from "@/utils";

type NewsletterSignupFormData = {
    [string]: string,
    email: string,
};

type Props = {
    portalId: string,
    formId: string,
};

const FormInitialState = {
    email: "",
};

const NewsletterSignupForm = ({formId, portalId}: Props): React$Element<typeof PromiseWatcher> => {
    const hsForm = new HubspotForm<NewsletterSignupFormData>(portalId, formId);
    const [promise, setPromise] = useState<Promise<any> | null>(null);

    const [form, setForm] = useState<NewsletterSignupFormData>(
        FormInitialState,
    );

    const onChange = (event: any) => {
        const { name, value } = event.target;
        setForm(form => ({
            ...form,
            [name]: value,
        }));
    };

    const onSubmit = (event: Event) => {
        event.preventDefault();
        setPromise(hsForm.submit(form));
    };

    promise
        ?.then(() => setForm(FormInitialState))
        .catch(() => {
            /* Ignored */
        });

    return (
        <PromiseWatcher promise={promise}>
            {value => (
                <Form
                    className={classNameOf(
                        "newsletter-signup-form",
                        value.type,
                    )}
                    onSubmitCapture={onSubmit}
                >
                    <input
                        type="email"
                        placeholder="Email"
                        name="email"
                        value={form.email}
                        onChange={onChange}
                    />
                    <PromiseWatcher promise={promise}>
                        {value => (
                            <ActionButton
                                variant="light"
                                state={value.type}
                                submit={true}
                            >
                                {value.type === "success"
                                    ? "Thank you"
                                    : "Sign up"}
                            </ActionButton>
                        )}
                    </PromiseWatcher>
                </Form>
            )}
        </PromiseWatcher>
    );
};

export default NewsletterSignupForm;
